import { getRolesRequest } from 'features/users/api';

export const fetchRoleItems = async () => {
  const { data } = await getRolesRequest();
  return data.map(role => ({ value: role.id, label: role.readable_name }));
};
